import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBKTRezWh4TEAdC17O8TWuju7dEBUrlZaw",
  authDomain: "veshh-eon.firebaseapp.com",
  projectId: "veshh-eon",
  storageBucket: "veshh-eon.firebasestorage.app",
  messagingSenderId: "981761118500",
  appId: "1:981761118500:web:de64222530bae7129ee3b1",
  measurementId: "G-BRR6DZSEBQ"
};

const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
